// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * @shapeshiftoss/solana-api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 10.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * Contains info about current recommended priority fees for a transaction to land.
 * @export
 * @interface PriorityFees
 */
export interface PriorityFees {
    /**
     * 
     * @type {string}
     * @memberof PriorityFees
     */
    baseFee: string;
    /**
     * 
     * @type {string}
     * @memberof PriorityFees
     */
    slow: string;
    /**
     * 
     * @type {string}
     * @memberof PriorityFees
     */
    average: string;
    /**
     * 
     * @type {string}
     * @memberof PriorityFees
     */
    fast: string;
}

/**
 * Check if a given object implements the PriorityFees interface.
 */
export function instanceOfPriorityFees(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "baseFee" in value;
    isInstance = isInstance && "slow" in value;
    isInstance = isInstance && "average" in value;
    isInstance = isInstance && "fast" in value;

    return isInstance;
}

export function PriorityFeesFromJSON(json: any): PriorityFees {
    return PriorityFeesFromJSONTyped(json, false);
}

export function PriorityFeesFromJSONTyped(json: any, ignoreDiscriminator: boolean): PriorityFees {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'baseFee': json['baseFee'],
        'slow': json['slow'],
        'average': json['average'],
        'fast': json['fast'],
    };
}

export function PriorityFeesToJSON(value?: PriorityFees | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'baseFee': value.baseFee,
        'slow': value.slow,
        'average': value.average,
        'fast': value.fast,
    };
}

